<table mat-table #table [dataSource]="dataSource" matSort>
  <ng-container [matColumnDef]="column" *ngFor="let column of columnNames">
    <span *ngIf='column == "select"'>
      <th mat-header-cell *matHeaderCellDef>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="primary">
        </mat-checkbox>
      </td>
    </span>
    <span *ngIf='column == "edit"'>
      <th mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td mat-cell *matCellDef="let row" class="delete-icon">
        <button  style="background: transparent;" [ngClass]="row?.excluded ? 'mat-dis':''" [disabled]="row?.excluded" (click)="triggerAction('edit',row)" class="material-icons custom-material-icon">
          edit
        </button>
      </td>
    </span>
    <span *ngIf='column == "delete"'>
      <th mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td mat-cell *matCellDef="let row" class="delete-icon">
        <button  style="background: transparent;" [ngClass]="row?.excluded ? 'mat-dis':''" [disabled]="row?.excluded" (click)="triggerAction('delete',row)" class="material-icons custom-material-icon">
          delete
        </button>
      </td>
    </span>
    <ng-container *ngIf="column !== 'actions'; else action">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{tableColumnsNames ? tableColumnsNames[column] : column}}
      </th>
      <td mat-cell *matCellDef="let object" [title]="object[column]" class="truncate-cell"> {{object[column]}} </td>
    </ng-container>
    <ng-template #action>
      <th mat-header-cell *matHeaderCellDef class="action-icon">Action</th>
      <td mat-cell *matCellDef="let object" >
        <button style="background: transparent;" class="material-icons custom-material-icon"
          [ngClass]="object?.excluded ? 'mat-dis':''" [disabled]="object?.excluded"
          (click)="triggerAction('edit',object)">
          edit
        </button>
        <button style="background: transparent;" class="material-icons custom-material-icon"
          [ngClass]="object?.excluded ? 'mat-dis':''" [disabled]="object?.excluded"
          (click)="triggerAction('delete',object)">
          delete
        </button>
      </td>
    </ng-template>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
  <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>
  <!-- <tr mat-row *matRowDef="let row; columns: columnNames;"
    [ngStyle]="row.excluded && {'background-color': 'lightgrey'}"></tr> -->
</table>
<mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
